var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#273476;}.c{fill:#ed2f31;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M236.189,824.108a2.212,2.212,0,0,0-2.264,2.157v12.687a2.212,2.212,0,0,0,2.264,2.157h6.576v-17Z",
    transform: "translate(-233.925 -824.108)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.525 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8.95,
    height: 17,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.16 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M374.109,824.108h-6.576v17h6.576a2.212,2.212,0,0,0,2.264-2.157V826.265A2.212,2.212,0,0,0,374.109,824.108Z",
    transform: "translate(-367.533 -824.108)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1596.885,922.289h6.449l-6.449-4.427Z",
    transform: "translate(-1580.047 -905.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1480.176,913.1v3.081a1.864,1.864,0,0,0,.033.344l4.926-3.344Z",
    transform: "translate(-1480.176 -901.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1480.209,837.956a1.876,1.876,0,0,0-.033.347v2.928l4.921.08Z",
    transform: "translate(-1480.176 -836.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1603.545,824.108h-6.66v4.521Z",
    transform: "translate(-1580.047 -824.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1640.326,837.954l-4.888,3.355,4.921-.08V838.3A1.869,1.869,0,0,0,1640.326,837.954Z",
    transform: "translate(-1614.359 -836.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1640.018,916.521a1.9,1.9,0,0,0,.033-.344V913.1l-4.959.081Z",
    transform: "translate(-1614.051 -901.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1509.577,824.108h-6.661l6.661,4.521Z",
    transform: "translate(-1500.415 -824.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1504.838,922.289h6.449v-4.427Z",
    transform: "translate(-1502.125 -905.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1490.073,830.054v-5.946h-.735v4.521l-6.661-4.521h-.631a1.859,1.859,0,0,0-1.1.363l6.557,4.585h-1.644l-5.5-3.877a1.855,1.855,0,0,0-.148.453l4.888,3.355-4.921-.08v1l6.4.1Z",
    transform: "translate(-1480.176 -824.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1590.2,904.173v5.8h.735v-4.427l6.449,4.427h.843a1.862,1.862,0,0,0,1.19-.427l-6.644-4.374h1.644l5.548,3.62a1.858,1.858,0,0,0,.1-.345l-4.926-3.344,4.959-.081v-1l-6.406.1Z",
    transform: "translate(-1574.098 -892.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1490.073,904.173l-3.491-.053-6.406-.1v1l4.959.081-4.926,3.344a1.866,1.866,0,0,0,.647,1.1l6.644-4.374h1.644l-7.074,4.8h.819l6.449-4.427v4.427h.735v-5.8Z",
    transform: "translate(-1480.176 -892.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1600.065,825.631a1.867,1.867,0,0,0-.733-1.16l-6.557,4.585h-1.644l7.076-4.947h-.61l-6.661,4.521v-4.521h-.735v5.946l3.5-.053,6.4-.1v-1l-4.921.08Z",
    transform: "translate(-1574.098 -824.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1494.479,830.965v-6.857h-2.607v6.857l-4.134-.061-7.562-.112v3.454l7.571.111,4.126.061v6.689h2.607v-6.689l4.125-.061,7.571-.111v-3.454l-7.563.112Z",
    transform: "translate(-1480.176 -824.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1488.967,831.99l-6.557-4.585a1.875,1.875,0,0,0-.585.708l5.5,3.877Z",
    transform: "translate(-1481.643 -827.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1600.291,829.055l6.557-4.585a1.86,1.86,0,0,0-1.1-.363h-.022l-7.076,4.947Z",
    transform: "translate(-1581.615 -824.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1613.6,914.456l6.644,4.374a1.871,1.871,0,0,0,.548-.754l-5.547-3.62Z",
    transform: "translate(-1594.92 -902.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1493,914.456l-6.644,4.374a1.861,1.861,0,0,0,1.19.427h.024l7.074-4.8Z",
    transform: "translate(-1485.679 -902.258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/englishFlag.033301842b8947bf46c5bdf19984a4bf.svg";
export { ForwardRef as ReactComponent };